import * as THREE from 'three';
import {manager} from '../../threejs/load/manager.js'
import { } from 'three/examples/jsm/loaders/RGBMLoader.js'
import { } from 'three/examples/jsm/loaders/RGBELoader.js'

//需要引入rebg系列的库 保证全局hdr亮度值的准确解析



var texLoader = new THREE.TextureLoader(manager)

function addMaterial(nam) {

    const imgPlath="./img/";
    const tex = texLoader.load( imgPlath+nam);
    tex.flipY = true
    // tex.encoding = THREE.BasicDepthPacking
    // tex.encoding = THREE.RGBADepthPacking

    tex.encoding =THREE.sRGBEncoding
    // tex.encoding = THREE.LinearEncoding
    // tex.format=THREE.AlphaFormat
    return (tex)
  }



const backimg=addMaterial('背景.jpg')

const envImg=addMaterial('env1.jpg')
envImg.mapping = THREE.EquirectangularReflectionMapping//专门针对金属反射映射贴图  

envImg.colorSpace = THREE.SRGBColorSpace;
export {backimg,envImg}
